{
  "satis_hedef_group": {
    "Baslik": "Satış Hedef Grup Tanımları",
    "Ad": "Grup Adı",
    "Birim": "Birim (TL/Dolar)",
    "UrunAta": "Ürün Ataması Yap",
    "UrunModeli Seç": "Ürün Seçin",
    "Urun Seç": "Ürün Seçin",
    "UrunAd": "Ürün Adı",
    "FirmaAd": "Firma Adı",
    "Products": "Atanmış Ürünler",
    "Ara": "Ara...",
    "Hepsi": "Hepsi",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Durum": "Durum",
    "Duzenle": "Düzenle",
    "Yeni Ekle": "Ekle",
    "Filtrele": "Filtrele",
    "Temizle": "Temizle",
    "Data Yenile": "Veriyi Yenile",
    "ARA": "ARA",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Dolar": "Dolar",
    "TL": "TL",
    "Ekle": "Ekle",
    "Guncelle": "Güncelle",
    "Kaydet": "Kaydet",
    "Iptal": "İptal",
    "Islem": "İşlem",
    "Urun yok": "Atanmış ürün bulunamadı"
  }
}
